import { Directive, ElementRef, HostListener, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
@Directive({
  selector: '[appVisibility]'
})
export class VisibilityDirective implements OnInit,OnDestroy {
   
    private animation: gsap.core.Tween;
    private scrollTrigger?: ScrollTrigger;
  
    constructor(
      private el: ElementRef,
      private zone: NgZone
    ) {
      gsap.registerPlugin(ScrollTrigger);
    }
  
    ngOnInit() {
      this.zone.runOutsideAngular(() => {
        // Initial setup
        gsap.set(this.el.nativeElement, {
          willChange: 'transform, opacity',
          backfaceVisibility: 'hidden'
        });
  
        // Create the animation
        this.animation = gsap.from(this.el.nativeElement, {
          y: '30vh', // Start further down for more dramatic effect
          opacity: 0,
          duration: 1.2,
          ease: "expo.out", // Smoother easing curve
          immediateRender: false,
          overwrite: 'auto',
          scrollTrigger: {
            trigger: this.el.nativeElement,
            start: "top bottom-=10%", // Triggers slightly before viewport
            end: "top 30%",
            scrub: 0.8, // Slightly longer scrub for smoother transitions
            markers: false,
            anticipatePin: 1, // Reduces jitter
            onEnter: () => this.animation.play(),
            onLeaveBack: () => this.animation.progress(0).pause(),
            onUpdate: self => {
              // Adaptive speed based on scroll velocity
              const velocity = Math.abs(self.getVelocity());
              gsap.to(this.animation, { 
                timeScale: Math.min(1, velocity / 100) 
              });
            }
          }
        });
  
        this.scrollTrigger = this.animation.scrollTrigger;
      });
    }
  
    ngOnDestroy() {
      if (this.scrollTrigger) {
        this.scrollTrigger.kill();
      }
      if (this.animation) {
        this.animation.kill();
      }
    }
}